"use strict";
const { showModal, closeModal } = require("./actions");

module.exports = {
  showModal,
  closeModal,
  Modal: require("./modal"),
  withEscapeHandler: require("./with-escape-handler"),
};
